import { Spin } from "antd";
import React, { useEffect, useState } from "react";

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0, 0, 0, 0.6)",
  zIndex: 99999999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

interface LoadingOverlayProps {
  loading: boolean;
  time?: number;
}

export default function LoadingOverlay({
  loading,
  time = 1000,
}: LoadingOverlayProps) {
  const [show, setShow] = useState(false);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (loading) {
      setShow(true);
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
    } else if (show) {
      const t = setTimeout(() => {
        setShow(false);
        setTimer(null);
      }, time);
      setTimer(t);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [loading]);

  if (!show) return null;
  return (
    <div style={overlayStyle}>
      <Spin size="large" />
    </div>
  );
}
